import { useState } from "react";
import { useSettings } from "@/context/SettingsContext";
import { CATEGORY_COLOR_KEYS, categoryDotCls } from "@/lib/constants";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function NewCategoryDialog({ open, onClose, onCreated }) {
  const { settings, addCategory } = useSettings();
  const [name, setName] = useState("");
  const [color, setColor] = useState("orange");

  const submit = () => {
    const n = name.trim();
    if (!n) return toast.error("Enter a category name");
    if ((settings?.categories || []).some((c) => c.name.toLowerCase() === n.toLowerCase())) return toast.error("That category already exists");
    const cat = addCategory(n, color);
    setName(""); setColor("orange");
    onCreated?.(cat);
    onClose();
    toast.success("Category added");
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-xs" data-testid="new-category-dialog">
        <DialogHeader>
          <DialogTitle className="text-lg font-extrabold">New category</DialogTitle>
          <DialogDescription>Give it a name and a color.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3 py-1">
          <div className="space-y-1.5">
            <Label>Name</Label>
            <Input data-testid="newcat-name-input" autoFocus value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") submit(); }} placeholder="e.g. Client work" />
          </div>
          <div className="space-y-1.5">
            <Label>Color</Label>
            <div className="flex flex-wrap gap-2">
              {CATEGORY_COLOR_KEYS.map((k) => (
                <button
                  key={k}
                  data-testid={`newcat-color-${k}`}
                  onClick={() => setColor(k)}
                  className={`w-7 h-7 rounded-full ${categoryDotCls(k)} transition-transform ${color === k ? "ring-2 ring-offset-2 ring-foreground scale-110" : "hover:scale-105"}`}
                  title={k}
                />
              ))}
            </div>
          </div>
        </div>
        <div className="flex justify-end gap-2">
          <Button variant="ghost" onClick={onClose} data-testid="newcat-cancel">Cancel</Button>
          <Button onClick={submit} data-testid="newcat-save" className="bg-primary hover:bg-[#E85D04] text-white font-semibold">Add category</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
